import axios from 'axios';

const backendBaseUrl = process.env.REACT_APP_BACKEND_URL;

// async function checkoutCart(cartInfo) {
//     try {
//         const response = await axios.post(backendBaseUrl + "products/payments/", cartInfo);
//         window.location.replace(response.data);
//     }
//     catch (error) {
//         console.log(error);
//     }
// }

async function getShippingQuote(data) {
    try {
        const response = await axios.post(backendBaseUrl + "shipping/quotes/", data);

        return response.data.rates;
    }
    catch (error) {
        console.log(error);
    }
}


async function getShippingConfirmation(data, courierData) {
    try {
        const payload = { ...data, courierData };
        const response = await axios.post(backendBaseUrl + "shipping/confirm/", payload);
        return response.data;
    }
    catch (error) {
        console.log(error);
        throw new Error("Shipping confirmation failed. Please try again.");
    }
}

async function getTaxes(cartItems, shipping, destination) {
    try {
        // Prepare the data to be sent in the request body
        const requestBody = {
            cartItems: cartItems,
            destination: {
                ...destination,
                shippingPrice: shipping,  // Including the shipping price in the destination object
            },
            currency: localStorage.getItem('selectedCurrency')
        };

        // Send a POST request to the backend to calculate tax
        const response = await axios.post(backendBaseUrl + "calculate-tax/", requestBody);

        // Parse the JSON response
        const taxData = await response.data.tax_amount_inclusive;

        return taxData;
    } catch (error) {
        console.error('Error fetching tax data:', error);
    }
} 

async function getPackingInfo(cartItems) {
  const transformedData = cartItems.dimensions.map(item => ({
  length: Math.ceil(item.TotalLength),
  width: Math.ceil(item.BaseDiameter),
  height: Math.ceil(item.BaseDiameter),
  weight: item.weight,
  description: item.description
}));

cartItems.dimensions = transformedData;

try {
  const response = await axios.post(backendBaseUrl + "shipping/packing/", cartItems);
  return response.data.boxes.content;
} catch (error) {
  console.log(error);
}

}

async function getDropInformation(){
    try {
        const response = await axios.get(backendBaseUrl + "drop/");
        return response.data;
    }
    catch (error){
        console.log(error);
    }
}

async function getDropEnded(){
    try {
        const response = await axios.get(backendBaseUrl + "drop/");
        return (response.data.max_uses <= response.data.uses);
    }
    catch (error){
        console.log(error);
    }
}

async function getCouponConfirmation(code, email, region){
    try {
        const requestBody = {
            code: code,
            email: email,
            region: region
        };
        const response = await axios.post(backendBaseUrl + "coupon/", requestBody);

        return response.data;
    }
    catch (error) {
        console.log(error);
    }
}

async function decreaseCoupon(code, email){
    try {
        const requestBody = {
            code: code,
            email: email
        };
        const response = await axios.post(backendBaseUrl + "coupon-use/", requestBody);
        return response.data;
    }
    catch (error) {
        console.log(error);
    }
}

async function decreaseDrop(){
    try {
        const response = await axios.post(backendBaseUrl + "decrease-drop/");
        return response.data;
    }
    catch (error) {
        console.log(error);
    }
}

export { getShippingQuote, getTaxes, getShippingConfirmation, getPackingInfo, getCouponConfirmation, decreaseCoupon, getDropInformation, decreaseDrop, getDropEnded };